import type { SupportedLocales } from '../../supportedLocales';
import type { LocaleDataSet, LocaleFileKey, LocaleFileType, LocalePluralOverrideKey, TimeFormat } from '../types';
import ar from './ar';
import az from './az';
import de from './de';
import el from './el';
import en from './en';
import es from './es';
import faAf from './fa_af';
import fr from './fr';
import hi from './hi';
import hu from './hu';
import id from './id';
import it from './it';
import ja from './ja';
import kk from './kk';
import ko from './ko';
import nl from './nl';
import pl from './pl';
import ps from './ps';
import pt from './pt';
import ptBR from './pt_br';
import ru from './ru';
import sv from './sv';
import th from './th';
import tr from './tr';
import uk from './uk';
import uz from './uz';
import vi from './vi';
import zh from './zh';
import zhTw from './zh_tw';

function objectifyTimeFormats(timeFormats: LocaleFileType): LocaleDataSet {
  const buildTimeFormat = (oneKey: LocaleFileKey, otherKey: LocaleFileKey): TimeFormat => {
    const pluralFormat: TimeFormat = {
      one: timeFormats[oneKey],
      other: timeFormats[otherKey],
    };

    const fewOverrideKey = `${otherKey}few` as LocalePluralOverrideKey;
    const fewOverrideValue = timeFormats[fewOverrideKey];

    if (fewOverrideValue) {
      pluralFormat.few = fewOverrideValue;
    }

    return pluralFormat;
  };

  return {
    days: {
      ddd: buildTimeFormat('d', 'dd'),
      dd: buildTimeFormat('dmid', 'ddmid'),
      d: buildTimeFormat('dmicro', 'ddmicro'),
    },
    hours: {
      hhh: buildTimeFormat('h', 'hh'),
      hh: buildTimeFormat('hmid', 'hhmid'),
      h: buildTimeFormat('hmicro', 'hhmicro'),
    },
    minutes: {
      mmm: buildTimeFormat('m', 'mm'),
      mm: buildTimeFormat('mmid', 'mmmid'),
      m: buildTimeFormat('mmicro', 'mmmicro'),
    },
    seconds: {
      sss: buildTimeFormat('s', 'ss'),
      ss: buildTimeFormat('smid', 'ssmid'),
      s: buildTimeFormat('smicro', 'ssmicro'),
    },
  };
}

const LocalesMap: Record<SupportedLocales, LocaleDataSet> = {
  ar: objectifyTimeFormats(ar),
  az: objectifyTimeFormats(az),
  de: objectifyTimeFormats(de),
  el: objectifyTimeFormats(el),
  en: objectifyTimeFormats(en),
  es: objectifyTimeFormats(es),
  es_LA: objectifyTimeFormats(es),
  'fa-af': objectifyTimeFormats(faAf),
  fr: objectifyTimeFormats(fr),
  fr_FR: objectifyTimeFormats(fr),
  hi: objectifyTimeFormats(hi),
  hu: objectifyTimeFormats(hu),
  id: objectifyTimeFormats(id),
  it: objectifyTimeFormats(it),
  ja: objectifyTimeFormats(ja),
  kk: objectifyTimeFormats(kk),
  ko: objectifyTimeFormats(ko),
  nl: objectifyTimeFormats(nl),
  pl: objectifyTimeFormats(pl),
  ps: objectifyTimeFormats(ps),
  pt: objectifyTimeFormats(pt),
  pt_br: objectifyTimeFormats(ptBR),
  pt_BR: objectifyTimeFormats(ptBR),
  ru: objectifyTimeFormats(ru),
  sv: objectifyTimeFormats(sv),
  th: objectifyTimeFormats(th),
  tr: objectifyTimeFormats(tr),
  uk: objectifyTimeFormats(uk),
  uz: objectifyTimeFormats(uz),
  vi: objectifyTimeFormats(vi),
  zh: objectifyTimeFormats(zh),
  'zh-tw': objectifyTimeFormats(zhTw),
};

export default LocalesMap;
